<div class='row justify-content-center align-items-center' *ngIf="lngRegistros && registrosXpagina">
  <div class='col-md-auto'>
    <p class="leyenda text-center mb-0 txt-texto">
      Página {{paginaActual}} ({{registroDesde}} - {{registroHasta}} de {{lngRegistros}})
    </p>
    
  </div>
  
    <div class="col-md-auto contenedor-paginacion">
      <button class="btn-paginacion" mat-icon-button color="primary" (click)="ejecutarAccion('primera')" [disabled]="paginaActual === 1">
        <mat-icon>first_page</mat-icon>
      </button>
      <button class="btn-paginacion" mat-icon-button color="primary" (click)="ejecutarAccion('anterior')" [disabled]="paginaActual === 1">
        <mat-icon>navigate_before</mat-icon>
      </button>
      <button class="btn-paginacion" mat-icon-button color="primary" (click)="ejecutarAccion('siguiente')" 
        [disabled]="(totalPaginas <= paginaActual)">
        <mat-icon>navigate_next</mat-icon>
      </button>
      <button class="btn-paginacion" mat-icon-button color="primary" (click)="ejecutarAccion('ultima')" 
        [disabled]="totalPaginas <= paginaActual  ">
        <mat-icon>last_page</mat-icon>
      </button>
    </div>
</div>
  <!-- <p class="leyenda text-center mb-0 txt-texto">{{registroDesde}} - {{registroHasta}} de {{lngRegistros}} </p>
  <p class="leyenda text-center mb-0 txt-texto">Página {{paginaActual}}</p> -->
